import React from 'react';
import { useTranslation } from 'react-i18next';

export const Header = () => {
  const { t } = useTranslation('corporates-club');

  return (
    <>
      <div className="header-container">
        <div data-testid="group-text-header" className="group-text-header">
          <h2>{t('title')}</h2>
          <p className="mt-4">{t('subtitle')}</p>
        </div>
        <div className="logo-circle-header" />
      </div>
    </>
  );
};
